exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subject-link{color:inherit;text-decoration:none}.subject-link:hover{text-decoration:underline}.filter-panel{max-height:0;overflow:hidden;transition:max-height .3s ease}.filter-panel-open{max-height:500px}.filter-panel-content{border:1px solid #dee2e6;border-radius:0 .25rem .25rem .25rem;padding:.75rem 1rem .5rem}.checkbox-columns{column-count:4;column-gap:1.5rem}@media (max-width:768px){.checkbox-columns{column-count:2}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6abf75ef","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Activity.vue
// module id = 877
// module chunks = 0